import Repository from './Repository';

const resource = "/placements_groups";
export default {
    page(website_id, page=1, limit=10, search='') {
        var offset = (page - 1) * limit
        let params = `limit=${limit}&offset=${offset}`
        if (website_id && website_id > 0) {
            params += `&website=${website_id}`
        }
        if (search) {
            params += `&search=${encodeURIComponent(search)}`
        }
        return Repository.get(`${resource}/?${params}`);
    },
    withWebsite(id) {
        return Repository.get(`${resource}/?website=${id}&limit=1000`);
    },
    ids(ids) {
        return Repository.get(`${resource}/?ids=${ids}&limit=1000`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    post(data) {
        return Repository.post(`${resource}/`, data);
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}/`, data);
    },
    patch(id, data) {
        return Repository.patch(`${resource}/${id}/`, data);
    },
}